import React from 'react';

import { CustomizedButton } from '@components/Customized';

import { CustomizedTypography } from '@components/Customized';
import { PurchaseOrderView } from '@components/Form/PurchaseOrder';

import { colorSet } from '@components/Provider';

import {
  Box,
  Grid,
  makeStyles,
  createStyles,
  IconButton,
  Dialog,
  DialogActions,
  useTheme,
  useMediaQuery,
  DialogContent
} from '@material-ui/core';

import CloseIcon from '@material-ui/icons/Close';
import FixedBottomCTA from './RightSide/FixedBottomCTA';

interface Props {
  open: boolean;
  onClose: () => void;
  rfqId: string;
  partnerId: string;
  chatRoomId?: string;
}

export default function OrderedQuotationDetailDialog(
  props: Props
): JSX.Element {
  const mobileClasses = mobileStyles();
  const desktopClasses = desktopStyles();
  const matches = useMediaQuery(useTheme().breakpoints.down('md'));

  const { open, onClose, rfqId, partnerId } = props;

  return (
    <>
      {open && !matches && (
        <Dialog
          open={open}
          onClose={onClose}
          className={desktopClasses.root}
          maxWidth="xs"
          scroll="paper"
        >
          <DialogContent dividers className={desktopClasses.content}>
            <PurchaseOrderView
              rfqId={rfqId}
              partnerId={partnerId}
              chatRoomId={props.chatRoomId}
              hasQuotations={true}
              hasPurchaseOrder={true}
              isHistory
            />
          </DialogContent>
          <DialogActions className={desktopClasses.footer}>
            <CustomizedButton
              className={desktopClasses.confirmButton}
              color="default"
              onClick={onClose}
            >
              닫기
            </CustomizedButton>
          </DialogActions>
        </Dialog>
      )}
      {open && matches && (
        <FixedBottomCTA
          className="OrderedQuotationDetailDialog"
          buttons={[
            {
              label: '닫기',
              color: 'default',
              variant: 'contained',
              action: onClose
            }
          ]}
          matches={matches}
        >
          <Grid container className={mobileClasses.root}>
            <Grid item className={mobileClasses.header}>
              <IconButton onClick={onClose}>
                <CloseIcon />
              </IconButton>

              <Box className="header-title">
                <CustomizedTypography
                  variant="body1"
                  fontWeight="500"
                  color="textPrimary"
                >
                  발주서
                </CustomizedTypography>
              </Box>
            </Grid>
            <Grid item className={mobileClasses.content}>
              <PurchaseOrderView
                rfqId={rfqId}
                partnerId={partnerId}
                chatRoomId={props.chatRoomId}
                hasQuotations={true}
                hasPurchaseOrder={true}
                isHistory
              />
            </Grid>
          </Grid>
        </FixedBottomCTA>
      )}
    </>
  );
}

const HEADER_HEIGHT = 48;
const ICON_BUTTON_WIDTH = 77;
const FOOTER_HEIGHT = 83;

const mobileStyles = makeStyles((theme) =>
  createStyles({
    root: {
      position: 'relative',
      height: '100%'
    },
    header: {
      position: 'fixed',
      width: `100%`,
      height: HEADER_HEIGHT,
      display: 'flex',
      alignItems: 'center',
      borderBottom: `1px solid ${colorSet.gray400}`,
      backgroundColor: colorSet.gray000,
      zIndex: 9,
      '& .header-title': {
        width: `calc(100% - ${ICON_BUTTON_WIDTH}px)`,
        textAlign: 'center'
      }
    },
    content: {
      paddingTop: HEADER_HEIGHT,
      paddingBottom: FOOTER_HEIGHT,
      width: `100%`,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: colorSet.gray000
    }
  })
);

const desktopStyles = makeStyles((theme) => {
  return createStyles({
    root: {
      '& .MuiPaper-root': {
        borderRadius: 16,
        minWidth: 600,
        maxHeight: 727
      }
    },

    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500]
    },
    content: {
      '&.MuiDialogContent-root:first-child': {
        paddingTop: 0
      }
    },
    footer: {
      display: 'flex',
      padding: `17px 24px`
    },
    confirmButton: {
      flexGrow: 1
    }
  });
});
